var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "main-root" },
    [
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c(
            "div",
            { staticClass: "search-icon" },
            [_c("w-fa", { attrs: { icon: "search" } })],
            1
          ),
          _c("w-input", {
            attrs: { label: _vm.$ct("search-field"), fancy: "" },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c("app-column-select-edit", {
        attrs: {
          value: _vm.value,
          model: _vm.model,
          label: _vm._label,
          browse: _vm.browse,
          favourites: _vm.favourites,
          "show-favourites": _vm.showFavourites,
          "filterable-only": _vm.isFilter,
          "filter-text": _vm.search,
          "is-server-column": _vm.isServerColumn,
          "nummeric-only": _vm.nummericOnly,
          "ignored-fields": _vm.ignoredFields,
          "preview-value": _vm.previewValue,
          "is-initial-render": _vm.isInitialRender,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
          name: function ($event) {
            return _vm.onName($event)
          },
        },
      }),
      _vm.browse
        ? _c("w-switch", {
            attrs: {
              value: _vm.showFavourites,
              disabled: !_vm.favourites || _vm.favourites.Columns.length == 0,
              label: _vm.$ct("only-show-favourites"),
              space: "",
            },
            on: {
              input: function ($event) {
                return _vm.setShowFavourites()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }